// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021245/js/" + chunkId + "." + {"44":"5f94f82b","225":"ddb13fdb","481":"21a768d2","486":"96a210e2","770":"818d125c"}[chunkId] + ".0.8846203702975334.chunk.js";
};